import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Col, Row, UncontrolledTooltip } from "reactstrap";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import {
  getInternshipStructures as onGetInternshipStructures,
  addNewInternshipStructure as onAddNewInternshipStructure,
  updateInternshipStructure as onUpdateInternshipStructure,
  deleteInternshipStructure as onDeleteInternshipStructure,
  getInternshipServices as onGetInternshipServices,

  resetInternshipStructureLastActionSuccess as OnResetInternshipStructureLastActionSuccess
} from "store/actions";

// Modal séparé
import InternshipStructureModal from "./partials/InternshipStructureModal";

const InternshipStructure = () => {
  document.title = "Structures de stage | CinzanEdu";
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [internshipStructure, setInternshipStructure] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loadingState, setLoadingState] = useState(true);

  // Selector structures
  const InternshipStructureProperties = createSelector(
    (state) => state.internshipStructureReducer,
    (reducer) => ({
      internshipStructures: reducer.internshipStructures,
      loading: reducer.loading,
      lastActionSuccess: reducer.lastActionSuccess
    })
  );
  const { internshipStructures, loading, lastActionSuccess } = useSelector(InternshipStructureProperties);

  // Selector services
  const InternshipServiceProperties = createSelector(
    (state) => state.internshipServiceReducer,
    (reducer) => ({
      internshipServices: reducer.internshipServices,
      loading: reducer.loading
    })
  );
  const { internshipServices } = useSelector(InternshipServiceProperties);

    // Chargement initial des données
    useEffect(() => {
        if (!internshipStructures.length) dispatch(onGetInternshipStructures());
        if (!internshipServices.length) dispatch(onGetInternshipServices());
        setLoadingState(loading);
    }, [dispatch, internshipStructures.length, internshipServices.length, loading]);


    // Ferme le modal en cas de success
    useEffect(() => {
        
        if (lastActionSuccess && modal) {
            toggle();
            setInternshipStructure(null);
            dispatch(OnResetInternshipStructureLastActionSuccess()); // action qui remet à false
        }
    }, [lastActionSuccess, modal, dispatch]);

  // Toggle modal
  const toggle = () => {
    setModal(!modal);
    if (modal) setInternshipStructure(null);
  };

  // Créer nouvelle structure
  const onClickNewInternshipStructure = () => {
    setIsEdit(false);
    setInternshipStructure(null);
    toggle();
  };

  // Edit structure
  const handleInternshipStructureClick = (structure) => {
    setInternshipStructure(structure);
    setIsEdit(true);
    toggle();
    dispatch(OnResetInternshipStructureLastActionSuccess()); // reset pour l’édition
  };

  // Delete structure
  const onClickDelete = (structure) => {
    setInternshipStructure(structure);
    setDeleteModal(true);
  };
  const handleDeleteInternshipStructure = () => {
    if (internshipStructure?.id) {
      dispatch(onDeleteInternshipStructure(internshipStructure));
      setDeleteModal(false);
    }
  };

  // Table columns
  const columns = useMemo(() => [
    { header: 'ID', accessorKey: "id", cell: cp => <Link to="#" className="text-body fw-bold">{cp.row.original.id}</Link> },
    { header: "Nom", accessorKey: "name" },
    { header: "Région", accessorKey: "region" },
    {
      header: 'Action',
      cell: cp => (
        <ul className="list-unstyled hstack gap-1 mb-0">
          <li>
            <Link
              to="#"
              className="btn btn-sm btn-soft-info"
              onClick={() => handleInternshipStructureClick(cp.row.original)}
              id={`edittooltip-${cp.row.original.id}`}
            >
              <i className="mdi mdi-pencil-outline" />
            </Link>
          </li>
          <li>
            <Link
              to="#"
              className="btn btn-sm btn-soft-danger"
              onClick={() => onClickDelete(cp.row.original)}
              id={`deletetooltip-${cp.row.original.id}`}
            >
              <i className="mdi mdi-delete-outline" />
            </Link>
          </li>
        </ul>
      )
    }
  ], []);

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteInternshipStructure}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Structures de stage" breadcrumbItem="Liste des structures de stage" />

          {loadingState ? (
            <Spinners setLoading={setLoadingState} />
          ) : (
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 card-title">Structures de stage</h5>
                    <Button color="primary" onClick={onClickNewInternshipStructure}>
                      Ajouter une structure de stage
                    </Button>
                  </CardBody>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={internshipStructures || []}
                      isCustomPageSize={true}
                      isPagination={true}
                      SearchPlaceholder="Rechercher ..."
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {/* Modal séparé */}
          <InternshipStructureModal
            modal={modal}
            toggle={toggle}
            isEdit={isEdit}
            internshipStructure={internshipStructure}
            internshipServices={internshipServices}
            onSubmit={(payload) => {
              if (isEdit) {
                dispatch(onUpdateInternshipStructure(payload));
              } else {
                dispatch(onAddNewInternshipStructure(payload));
              }
              //toggle(); // 🔹 Fermeture automatique après succès
            }}
          />
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default InternshipStructure;
